<template>
  <a-tree
    checkable
    :auto-expand-parent="true"
    :tree-data="treeData"
    :replaceFields="{ children: 'children', title: 'label', key: 'id' }"
    @check="check"
    v-model:checkedKeys="arr"
  />
</template>
<script>
import { reactive, ref, watch } from "vue";
import menuApi from "@axios/sys/menu";

export default {
  componentname: "selectMenuTree",
  props: {
    title: {
      type: String,
      default: "请选择菜单",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    model: {
      type: Object,
      default: function() {
        return {
          menuIds: undefined,
        };
      },
    },
  },
  setup(props, context) {
    console.log(props.model.menuIds);
    let arr = [];
    let treeData = ref([]);
    let menuIds = ref([]);
    const roleListTree = (value) => {
      let params = {};
      menuApi
        .menuListTree(params)
        .then((res) => {
          console.log(res);
          treeData.value = res;
          Object.values(props.model.menuIds).forEach((item, index) => {
            arr.push(item);
          });
        })
        .catch(() => {});
    };

    const check = (value, bool) => {
      console.log(value, "value");
      console.log(bool.checkedNodes, "parentNode");
      context.emit("setValue", {
        val: value,
      });
      arr = [];
      value.forEach((item, index) => {
        arr.push(item);
      });
    };
    watch(arr, () => {
      console.log("checkedKeys", arr);
    });
    roleListTree();
    return {
      check,
      roleListTree,
      treeData,
      menuIds,
      model: props.model,
      arr,
    };
  },
  watch: {},
};
</script>
